import { useState } from 'react';
import { GridSortItem, GridSortModel } from '@mui/x-data-grid';

// TODO: To be implemented with backend changes
export const useSorting = () => {
  const [sorting, setSorting] = useState<GridSortItem>({
    sort: 'desc',
    field: ''
  });

  const applySorting = (model: GridSortModel) => {
    if (!model.length) {
      setSorting({
        sort: 'desc',
        field: ''
      });
      return;
    }

    setSorting(model[0]);
  };

  return { sorting, applySorting };
};
